import { Fragment } from "react";
import { Link } from "react-router-dom";

const INLINE = /(\[[^\]]+\]\([^)\s]+\)|\*\*[^*]+\*\*)/g;

const Inline = ({ text, onNavigate }) =>
  text.split(INLINE).map((part, i) => {
    const link = part.match(/^\[([^\]]+)\]\(([^)\s]+)\)$/);
    if (link) {
      const [, label, href] = link;
      return href.startsWith("/")
        ? <Link key={i} to={href} onClick={onNavigate} className="font-semibold text-[#C20500] underline-offset-2 hover:underline">{label}</Link>
        : <a key={i} href={href} target="_blank" rel="noreferrer" className="font-semibold text-[#C20500] hover:underline">{label}</a>;
    }
    if (/^\*\*[^*]+\*\*$/.test(part)) return <strong key={i}>{part.slice(2, -2)}</strong>;
    return <Fragment key={i}>{part}</Fragment>;
  });

export const MiniMarkdown = ({ text, onNavigate }) => {
  const blocks = [];
  text.split("\n").forEach((line) => {
    const bullet = line.match(/^\s*(?:[-*•]|\d+\.)\s+(.*)$/);
    const last = blocks[blocks.length - 1];
    if (bullet) {
      if (last?.type === "ul") last.items.push(bullet[1]);
      else blocks.push({ type: "ul", items: [bullet[1]] });
    } else if (line.trim()) blocks.push({ type: "p", text: line.replace(/^#+\s*/, "") });
  });
  return (
    <div className="space-y-2">
      {blocks.map((b, i) =>
        b.type === "ul" ? (
          <ul key={i} className="list-disc space-y-1 pl-5">{b.items.map((it, j) => <li key={j}><Inline text={it} onNavigate={onNavigate} /></li>)}</ul>
        ) : <p key={i}><Inline text={b.text} onNavigate={onNavigate} /></p>
      )}
    </div>
  );
};
